// Core imports
import * as React from 'react';
import LocaleFormating from 'src/translation/localeFormating';
import env from 'src/shared/env';

// Components imports
import InvoiceModel from 'src/model/invoice.model';
import RadioButton from 'src/components/common/RadioButton';
import Button from 'src/components/common/Button';
import InvoiceToPay from '../InvoiceToPay';
import CheckPrintable from '../CheckPrintable';
import ECheckModalMobile from '../ECheckModalMobile';
import Input from 'src/components/common/Input';
import Alert from 'src/components/common/Alert';
import UserModel from 'src/model/user.model';

// Models imports
import { IInvoiceCreditPayment } from 'src/services/invoice/InvoiceService';
import CreditCardModel from 'src/model/creditCard.model';
import {
  ICreditCardError,
  ICreditCardSuccess
} from 'src/store/modules/creditcard/reducers';

// Style and misc imports
import './PaymentModeMobile.scss';

class PaymentModeMobile extends React.Component<
  IPaymentModeMobileProps,
  IPaymentModeMobileState
> {
  constructor(props: IPaymentModeMobileProps) {
    super(props);

    this.state = {
      selectedMode: 'check',
      showECheckModalMobile: false,
      payableInvoices: 0,
      printCheck: false,
      invoicesPaymentData: [],
      isPaymentDisabled: false,
      creditSignature: '',
      invoices: []
    };
  }

  /* 
    getTotalDue
   */
  private getTotalDue = (): {
    total: number;
    totalDebit: number;
    totalCredit: number;
  } => {
    let total: number = 0;
    let totalCredit: number = 0;
    let totalDebit: number = 0;
    this.state.invoicesPaymentData.map(invoice => {
      total =
        Number(total.toFixed(2)) +
        Number(invoice.payment ? invoice.payment : 0);
      if (invoice.payment && invoice.payment > 0) {
        totalDebit = Number(totalDebit.toFixed(2)) + Number(invoice.payment);
      } else {
        totalCredit = Number(totalCredit.toFixed(2)) + Number(invoice.payment);
      }
    });
    return {
      total: Number(total.toFixed(2)),
      totalDebit: Number(totalDebit.toFixed(2)),
      totalCredit: Number(totalCredit.toFixed(2))
    };
  };

  /* 
    setSelectedPaymentMode
   */
  private setSelectedPaymentMode = (event: any) => {
    this.setState({
      selectedMode: event.target.value
    });
    this.props.clearAlert();
  };

  /* 
    getSelectedMode
   */
  private getSelectedMode = () => {
    const selections = {
      creditCard: false,
      check: false,
      echeck: false,
      credit: false
    };

    selections[this.state.selectedMode] = true;
    return selections;
  };

  /* 
    getInvoicesToPay
   */
  private getInvoicesToPay = (): {
    credits: JSX.Element[];
    invoices: JSX.Element[];
  } => {
    const invoices: JSX.Element[] = [];
    const credits: JSX.Element[] = [];

    this.state.invoices.map((invoice, index) => {
      if (invoice.remainingAmount < 0) {
        credits.push(
          <InvoiceToPay
            key={index}
            invoice={invoice}
            onDataChange={this.handleInvoicePaymentValues}
          />
        );
      } else {
        invoices.push(
          <InvoiceToPay
            key={index}
            invoice={invoice}
            onDataChange={this.handleInvoicePaymentValues}
          />
        );
      }
    });

    return { credits, invoices };
  };

  /* 
    handleCloseCheck
   */
  private handleCloseCheck = () => {
    this.setState({ printCheck: false });
  };

  /* 
    handleCloseCheck
   */
  private handlePayment = () => {
    switch (this.state.selectedMode) {
      case 'check':
        this.setState({ printCheck: true });
        this.props.clearAlert();
        break;
      case 'creditCard':
        this.handleCreditCardPayment();
        this.props.clearAlert();
        break;
      case 'echeck':
        this.setState({ showECheckModalMobile: true });
        this.props.clearAlert();
        break;
      case 'credit':
        this.handleCreditPayment();
        this.props.clearAlert();
        break;
      default:
        break;
    }
  };

  private handleCreditPayment = () => {
    const invoicesToPay: IInvoiceCreditPayment[] = [];

    this.state.invoicesPaymentData.forEach(invoice => {
      invoicesToPay.push({
        orderNumber: invoice.orderNumber,
        paymentAmount: invoice.payment,
        reasonRemainingBalance: invoice.notes,
        transactionId: invoice.transactionId
      });
    });

    this.props.payInvoicesByCredit(invoicesToPay, this.state.creditSignature);
  };

  private handleCreditCardPayment = () => {
    const invoicesToPay: IInvoiceCreditPayment[] = [];

    this.state.invoicesPaymentData.forEach(invoice => {
      invoicesToPay.push({
        orderNumber: invoice.orderNumber,
        paymentAmount: invoice.payment,
        reasonRemainingBalance: invoice.notes,
        transactionId: invoice.transactionId
      });
    });

    this.props.payInvoicesByCreditCard(
      invoicesToPay,
      this.props.selectedCreditCard.id
    );
  };

  /* 
    handleInvoicePaymentValues
   */
  private handleInvoicePaymentValues = (
    invoicePayment: IInvoicePaymentData
  ) => {
    const index = this.state.invoicesPaymentData.findIndex(
      invoice => invoice.invoiceNumber === invoicePayment.invoiceNumber
    );

    const paymentData: IInvoicePaymentData[] = [
      ...this.state.invoicesPaymentData
    ];
    if (index === -1) {
      paymentData.push(invoicePayment);
    } else {
      paymentData[index] = invoicePayment;
    }

    this.setState({ invoicesPaymentData: paymentData }, () => {
      if (
        !invoicePayment.payment ||
        (invoicePayment.remaining > 0 && !invoicePayment.notes)
      ) {
        this.setState({
          isPaymentDisabled: true
        });
      } else {
        let isDisabled = false;
        for (const invoice of this.state.invoicesPaymentData) {
          if (
            !invoice.payment ||
            (invoicePayment.remaining > 0 && !invoicePayment.notes)
          ) {
            isDisabled = true;
            break;
          }
        }

        this.setState({
          isPaymentDisabled: isDisabled
        });
      }
    });
  };

  /* 
    prepareCheckData
   */
  private prepareCheckData = () => {
    const preparedData: IInvoicePaymentData[] = [];
    this.props.selectedInvoices.forEach(invoice => {
      const paymentData: IInvoicePaymentData = {
        transactionId: invoice.transactionId,
        invoiceDate: invoice.dueDate,
        invoiceNumber: invoice.invoiceNumber,
        orderNumber: invoice.orderNumber,
        payment: invoice.remainingAmount,
        remaining: 0,
        total: invoice.remainingAmount,
        notes: ''
      };
      preparedData.push(paymentData);
    });
    this.setState({ invoicesPaymentData: preparedData });
  };

  private onCreditSignatureChange = (creditSignature: string) => {
    this.setState({ creditSignature });
  };

  private renderAlert() {
    const getMessage = () =>
      this.props.errorPayment.hasFailed
        ? this.props.errorPayment.message
        : this.props.successPayment.hasSucceed
        ? this.props.successPayment.message
        : this.props.creditCardError.hasFailed
        ? this.props.creditCardError.message
        : this.props.creditCardSuccess.message;

    return (this.props.errorPayment && this.props.errorPayment.hasFailed) ||
      (this.props.successPayment && this.props.successPayment.hasSucceed) ||
      (this.props.creditCardError && this.props.creditCardError.hasFailed) ||
      (this.props.creditCardSuccess &&
        this.props.creditCardSuccess.hasSucceed) ? (
      <div className="rp-payment-mode-desktop--alert">
        <Alert
          styleClass="paymentAlert"
          message={!this.props.creditCardError.hasFailed && getMessage()}
          icon={
            this.props.errorPayment.hasFailed ||
            this.props.creditCardError.hasFailed
              ? 'rpds-error'
              : 'rpds-check-circle'
          }
          handleCloseAlert={() => {
            return;
          }}
          type={
            this.props.errorPayment.hasFailed ||
            this.props.creditCardError.hasFailed
              ? 'error'
              : 'success'
          }
        >
          {this.props.creditCardError.hasFailed &&
            getMessage()
              .split('-')
              .map((msg: string, idx: number) => <span key={idx}>{msg}</span>)}
        </Alert>
      </div>
    ) : null;
  }

  private renderCreditCardOptions = () => {
    const { t } = this.props;
    return this.props.savedCreditCards &&
      this.props.savedCreditCards.length > 0 ? (
      this.props.creditCardIsPending ? (
        <span className="rp-invoices--saved-cards warning">
          {t('payments.inProcessDoNotLeavePage')}
        </span>
      ) : (
        <div className="rp-invoices--saved-cards">
          {this.props.savedCreditCards.map(card => (
            <RadioButton
              key={card.id}
              name={`**** **** **** ${card.number}`}
              extraText={card.type}
              value={card.id}
              checked={
                card.id === this.props.selectedCreditCard.id ? true : false
              }
              className="rp-radio-button--saved-card"
              onChange={e => this.props.onSelectCreditCard(card)}
            />
          ))}
        </div>
      )
    ) : (
      <span className="rp-invoices--saved-cards">
        {t('common.noSavedCard')}
      </span>
    );
  };

  /* 
    renderPaymentMethod
   */
  private renderPaymentMethod() {
    if (this.state.printCheck) {
      return (
        <CheckPrintable
          invoices={this.state.invoicesPaymentData}
          closeWindow={() => {
            this.handleCloseCheck();
          }}
          userAccount={this.props.userAccount}
          user={this.props.userData}
        />
      );
    } else if (this.state.showECheckModalMobile) {
      return (
        <ECheckModalMobile
          onCloseMenu={this.props.handleCloseMenu}
          invoices={this.state.invoicesPaymentData}
          userAccount={this.props.userAccount}
        />
      );
    } else {
      // TODO: Credit card component
      return <div />;
    }
  }

  private renderProceedPayment() {
    const { t } = this.props;
    const { total, totalDebit, totalCredit } = this.getTotalDue();
    return (
      <React.Fragment>
        {this.state.selectedMode === 'credit' && (
          <Input
            label={t('common.paymentSignature')}
            value={this.state.creditSignature}
            onChange={this.onCreditSignatureChange}
            required={true}
            className="rp-payment-mode--signature"
          />
        )}
        {this.state.selectedMode === 'credit' && (
          <div className="payment-total">
            <p>{`Credit: ${LocaleFormating.formatCurrency(totalCredit)}`}</p>
            <p>{`Debit: ${LocaleFormating.formatCurrency(totalDebit)}`}</p>
          </div>
        )}
        <span className="payment-total">{`${t(
          'common.total'
        )}: ${LocaleFormating.formatCurrency(total)}`}</span>
        <Button
          buttonClass="primary-custom-button"
          label={t('invoices.payInvoiceWithCount', {
            count: this.state.payableInvoices
          })}
          textTransform="uppercase"
          height="56px"
          width="100%"
          action={() => {
            this.handlePayment();
          }}
          disabled={
            this.state.isPaymentDisabled ||
            (this.state.selectedMode === 'credit' &&
              !this.state.creditSignature) ||
            total < 0 ||
            (this.state.selectedMode !== 'credit' && total === 0) ||
            (this.props.successPayment &&
              this.props.successPayment.hasSucceed) ||
            (this.state.selectedMode === 'creditCard' &&
              (!this.props.selectedCreditCard ||
                this.props.creditCardIsPending)) ||
            (this.props.creditCardSuccess &&
              this.props.creditCardSuccess.hasSucceed)
          }
        />
        {this.state.selectedMode === 'credit' && (
          <span className="credit-items-offset">
            {`${t('invoices.creditsItemsOffset')}`}
          </span>
        )}
      </React.Fragment>
    );
  }

  public componentDidMount() {
    this.props.getUserDetails();
    this.prepareCheckData();
    this.setState({
      payableInvoices: this.props.selectedInvoices.length,
      invoices: this.props.selectedInvoices
    });
    this.props.getSavedCards();
  }

  public render() {
    const { t } = this.props;
    const methodSelection = this.getSelectedMode();
    const credits = this.getInvoicesToPay().credits;
    const invoices = this.getInvoicesToPay().invoices;

    return (
      <div className="rp-payment-mode-mobile">
        <div className="rp-payment-mode-mobile--content">
          {this.renderPaymentMethod()}
          {this.renderAlert()}
          <div className="rp-payment-mode-mobile--payment-methods">
            <h1 className="payments-title">{t('payment.chooseMethod')}</h1>
            <div className="payment-method">
              <RadioButton
                name={t('payment.byCheck')}
                value="check"
                checked={methodSelection.check}
                onChange={event => {
                  this.setSelectedPaymentMode(event);
                }}
              />
            </div>

            {env.REACT_APP_INVOICE_CC_PAYMENT === 'true' && (
              <div className="payment-method">
                <RadioButton
                  name={t('payment.byCreditCard')}
                  value="creditCard"
                  checked={methodSelection.creditCard}
                  onChange={event => {
                    this.setSelectedPaymentMode(event);
                  }}
                />
                {methodSelection.creditCard && this.renderCreditCardOptions()}
              </div>
            )}

            {env.REACT_APP_BASE_ENVIRONMENT === 'US' && (
              <div className="payment-method">
                <div className="payment-title">
                  <span className="title">{t('payment.secureExternal')}</span>
                </div>
                <RadioButton
                  name={t('payment.byEcheck')}
                  value="echeck"
                  checked={methodSelection.echeck}
                  onChange={event => {
                    this.setSelectedPaymentMode(event);
                  }}
                />
              </div>
            )}
            <div className="payment-method">
              <RadioButton
                name={t('payment.byCredit')}
                value="credit"
                checked={methodSelection.credit}
                onChange={event => {
                  this.setSelectedPaymentMode(event);
                }}
              />
            </div>
            {this.renderProceedPayment()}
          </div>

          <div className="rp-payment-mode-mobile--invoices-to-pay">
            {credits.length > 0 && (
              <React.Fragment>
                <h1 className="invoices-title">
                  {t('invoices.credit_plural')}
                </h1>
                {credits}
              </React.Fragment>
            )}
            {invoices.length > 0 && (
              <h1 className="invoices-title">{t('invoices.invoice_plural')}</h1>
            )}
            {invoices}
          </div>
        </div>
      </div>
    );
  }
}

export default PaymentModeMobile;

interface IPaymentModeMobileProps {
  t: any;
  errorPayment: any;
  successPayment: any;
  selectedInvoices: InvoiceModel[];
  userAccount: string;
  savedCreditCards: CreditCardModel[];
  selectedCreditCard: CreditCardModel;
  creditCardError: ICreditCardError;
  creditCardSuccess: ICreditCardSuccess;
  creditCardIsPending: boolean;
  userData: UserModel;
  handleCloseMenu: () => void;
  payInvoicesByCredit: (
    invoicePayments: IInvoiceCreditPayment[],
    signature: string
  ) => void;
  clearAlert: () => void;
  getSavedCards: () => void;
  onSelectCreditCard(creditCard: CreditCardModel): void;
  payInvoicesByCreditCard: (
    invoicePayments: IInvoiceCreditPayment[],
    cardId: string
  ) => void;
  getUserDetails: () => void;
}

interface IPaymentModeMobileState {
  selectedMode: 'check' | 'creditCard' | 'echeck' | 'credit';
  showECheckModalMobile: boolean;
  payableInvoices: number;
  invoicesPaymentData: IInvoicePaymentData[];
  printCheck: boolean;
  isPaymentDisabled: boolean;
  creditSignature: string;
  invoices: InvoiceModel[];
}

export interface IInvoicePaymentData {
  transactionId: number;
  invoiceDate: string;
  invoiceNumber: number;
  orderNumber: number;
  payment: number;
  remaining: number;
  total: number;
  notes: string;
}
